<template>
  <div id="LoginBox" class="">
    <div class="login_logo">
      <a href="/" class="logo"></a>
      <h1 class="line_h1">绑定已有Card Hobby账号</h1>
    </div>
    <div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item class="login_form_item" prop="Account">
          <div class="locationPhoneBox login_location" v-if="ruleForm.Type=='1'">
            <div class="countries" v-if="location.MemberSource!=''">
              <img :src="location.LocationIcon" alt="">
            </div>
            <el-select class="login_ipt" :class="location.MemberSource!=''?'nolocation':''" placeholder="" v-model="location.MemberSource" popper-class='location' @change='changeLocation'>
              <el-option class="locationelOption" :label="item.EnName" :value="item.Code" v-for="(item,index) in locationOption" :key='index'>
                <div class="locationOption">
                  <img :src="item.IconUrl">
                  <span>{{item.EnName}}</span>
                </div>
              </el-option>
            </el-select>
            <div class="nationCode">
              {{location.AreaCode}}
            </div>
          </div>
          <el-input class="login_ipt first_login_ipt email" v-model="ruleForm.Account" :placeholder="$t('base.phoneNumber')" autocomplete="off" @input='emailInput'></el-input>
        </el-form-item>
        <el-form-item class="login_form_item" prop="Password">
          <el-input class="login_ipt" :type="flagType" v-model="ruleForm.Password" :placeholder="$t('base.password')" @input="search" autocomplete="off">
            <i slot="suffix" class="showing" :class="[flag == true?'show':'noshow']" v-show="ifshow" @click="getFlag()" />
          </el-input>
        </el-form-item>
        <div class="forgot">
          <span class="text_blue" @click="goto('ruleForm')">{{$t('symbol.forgotPwd')}}</span>
        </div>
        <el-button class="text_btn" :disabled="disabled" type="primary" @click="submitForm('ruleForm')">绑定并登录</el-button>
      </el-form>
      <div class="terms_checked">
        <el-checkbox v-model="checkbox" :label="1">{{radioNumber}}</el-checkbox>
        <div>
          {{$t('base.agreeTo')}} <router-link class="text_blue" :to="{path:'/terms/privacy?type=2'}" target="_blank">{{$t('base.service')}}</router-link> {{$t('base.and')}} <router-link class="text_blue" :to="{path:'/terms/privacy?type=1'}" target="_blank">{{$t('base.privacy')}}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { CensoredEmail, getUser } from "@/api/public";
export default {
  name: '',
  data() {
    var userValidate = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('rules.invalidPhone')));
      } else if (value != '') {
        callback();
      } else if (this.smsMsg) {
        callback(new Error(this.smsMsg));
      } else {
        callback();
      }
    };
    var passValidate = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('rules.emailPwdIncorrect')));
      } else if (this.psMsg) {
        callback(new Error(this.psMsg));
      } else {
        callback();
      }
    };
    return {
      flagType: 'password',
      flag: false,
      radioNumber: '',
      checkbox: false,
      ifshow: false,
      disabled: false,
      psMsg: '',
      smsMsg: '',
      location: {
        MemberSource: '',
        LocationIcon: '',
        LocationName: '',
        AreaCode: ''
      },
      ruleForm: {
        Account: '', //邮箱或手机
        Password: '', //密码
        Type: '1', //登录类型 0邮箱 1手机号
        AreaCode: '' //手机区号
      },
      rules: {
        Account: [
          { validator: userValidate, trigger: 'blur' },
          //{ type: 'email', message: 'Enter the email address like this: name@email.com', trigger: 'blur' },
        ],
        Password: [
          { validator: passValidate }
        ]
      },
    }
  },
  props: {
    gdata: {},
    locationOption: {}
  },

  watch: {
    'locationOption': {
      handler(obj) {
        //console.log(obj,'locationOption')
        this.getNationIcons()
      }
    }
  },
  created() {},
  mounted() {
    this.getNationIcons()
  },
  methods: {
    // 修改国家
    changeLocation(e) {
      let that = this
      that.locationOption.map(res => {
        if (res.Code == e) {
          that.location.MemberSource = res.Code //
          that.location.LocationIcon = res.IconUrl
          that.location.LocationName = res.EnName
          that.location.AreaCode = res.NationCode
          that.ruleForm.AreaCode = res.NationCode
        }
      })
      //console.log(that.ruleForm)
    },
    //获取全部国家图标地址
    getNationIcons() {
      let that = this
      try {
        const locationOne = this.locationOption[0]
        that.location.MemberSource = locationOne.Code
        that.location.LocationIcon = locationOne.IconUrl
        that.location.LocationName = locationOne.EnName
        that.location.AreaCode = locationOne.NationCode
        that.ruleForm.AreaCode = locationOne.NationCode
      } catch (error) {}
    },
    //是否显示查看密码的图标
    search() {
      if (this.ruleForm.Password.length > 0) {
        this.ifshow = true
      } else {
        this.ifshow = false
      }
    },
    //密码切换状态
    getFlag() {
      this.flag = !this.flag
      this.flagType = this.flag ? 'text' : 'password' //text为显示密码；password为隐藏密码
      //console.log(this.flag,this.flagType)
    },
    // 删除email清空密码
    emailInput() {
      if (this.ruleForm.Account.length < 1) {
        this.ruleForm.Password = ''
      }
    },
    // 有邮箱跳转忘记密码
    goto(formName) {
      let that = this;
      let query = { account: that.ruleForm.Account, type: that.ruleForm.Type }
      if (that.ruleForm.Type == '1') {
        query.source = that.location.MemberSource
      }
      this.$router.push({
        path: '/forgot',
        query: query
      })
    },
    // 登入
    submitForm(formName) {
      let that = this;
      that.psMsg = "", that.smsMsg = ""
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var data = that.ruleForm
          if (that.ruleForm.Type != '1') {
            data.AreaCode = '+86'
          }
          if (this.checkbox == false) {
            this.$confirm(`<div style="padding: 0 24px;">` + that.$t('alert.toProceed') + ` <a href="#/terms/privacy?type=2"  target="_blank" class="text_blue">` + that.$t('base.service') + `</a> ` + that.$t('base.and') + ` <a href="#/terms/privacy?type=1"  target="_blank" class="text_blue">` + that.$t('base.privacy') + `</a>.</div>`, that.$t('base.notice'), {
                // showConfirmButton: true ,
                customClass: "NoticeBox",
                dangerouslyUseHTMLString: true,
                confirmButtonText: that.$t('base.agree'),
                cancelButtonText: that.$t('base.cancel'),
              }).then(() => {
                this.checkbox = true;
                this.submitForm('ruleForm');
              })
              .catch(() => {

              });
          } else {
            this.disabled = true;
            that.loading = true;
            this.$post(this.$interface.SignIn, data).then(res => {
              //console.log(res.Data)
              if (res.Result != 0) {

                if (res.Data.EMail || res.Data.Email) {
                  res.Data.Email = CensoredEmail(res.Data.EMail || res.Data.Email)
                }
                that.bindGoogleUserId(res.Data)
              } else {
                if (res.Msg.toLowerCase().indexOf('password') != -1) {
                  that.psMsg = res.Msg
                  that.$refs[formName].validateField("Password");
                } else {
                  that.smsMsg = res.Msg
                  that.$refs[formName].validateField("Account");
                }
                this.$message({
                  type: 'error',
                  duration: 2000,
                  message: res.Msg
                });
                that.loading = false;
                //that.$refs[formName].validateField("email");
                that.disabled = false;
              }
            }).catch(error => {
              that.loading = false;
              that.disabled = false;
            })
          }
        }
      })
    },
    //绑定google用户
    bindGoogleUserId(obj) {
      let that = this
      try {
        const data = {
          GoogleUserId: that.gdata.sub,
          MemberId: obj.Id
        }
        that.$post(that.$interface.BindGoogleUserId, data).then(res => {
          if (res.Result != 0) {

            getUser(obj)
            setTimeout(function() {
              that.loading = false;
              that.disabled = false;
            }, 1000)
          } else {

            this.$message({
              type: 'error',
              duration: 2000,
              message: res.Msg
            });
            that.loading = false;
            that.disabled = false;
          }
        })
      } catch (error) {}
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../static/css/login.css";

</style>



// WEBPACK FOOTER //
// src/components/googlebinding.vue